import { action } from 'satcheljs';
/**
 * Dispatched to clear current search scope (i.e. change it to broadest scope).
 * Action message provides option to kick off search after scope is changed.
 *
 * Currently, this action is only used in MailListEmptyViewState component.
 */
export var clearSearchScope = action('CLEAR_SEARCH_SCOPE', function (actionSource, shouldStartSearch, searchScopeKind) { return ({
    actionSource: actionSource,
    shouldStartSearch: shouldStartSearch,
    searchScopeKind: searchScopeKind,
}); });
export var loadMessageSuggestionIntoTable = action('LOAD_MESSAGE_SUGGESTION_INTO_TABLE', function (actionSource, row, searchTableQuery, referenceId, traceId, itemPartId) { return ({
    actionSource: actionSource,
    row: row,
    searchTableQuery: searchTableQuery,
    referenceId: referenceId,
    traceId: traceId,
    itemPartId: itemPartId,
}); });
export var loadTableViewFromSearchTableQuery = action('LOAD_TABLE_VIEW_FROM_SEARCH_TABLE_QUERY', function (searchTableQuery, searchEndToEndPerformanceDatapoint, actionSource) { return ({
    searchTableQuery: searchTableQuery,
    searchEndToEndPerformanceDatapoint: searchEndToEndPerformanceDatapoint,
    actionSource: actionSource,
}); });
export var removeSearchTableFromStore = action('REMOVE_SEARCH_TABLE_FROM_STORE', function (tableViewId) { return ({
    tableViewId: tableViewId,
}); });
/**
 * This action is to be dispatched after search is exited and we need
 * to re-select the previous node the user was on before entering into
 * their search session.
 */
export var selectPreviousNode = action('SELECT_PREVIOUS_NODE', function (actionSource) { return ({
    actionSource: actionSource,
}); });
export var setStaticSearchScope = action('SET_STATIC_SEARCH_SCOPE', function (searchScope) { return ({
    searchScope: searchScope,
}); });
export var startSearchWithCategory = action('START_SEARCH_WITH_CATEGORY', function (actionSource, categoryName) { return ({
    actionSource: actionSource,
    categoryName: categoryName,
}); });
//# sourceMappingURL=publicActions.js.map